////////LIBRARY/////////
import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { Transition } from 'react-transition-group'
import { shallowEqual, useSelector } from 'react-redux'
import { map, isEmpty } from 'lodash'
///////COMPONENTS///////
import UserAuthorizationLayout from '../../../../components/UserAuthorizationLayout'
/////////ASSETS/////////
import DropIcon from '../../../../assets/icones/menu/menu-open-close.svg'

/////////STYLED/////////
const MenuLinkWrapper = styled.div`
	display: flex;
	flex-direction: row;
	background-color: ${(props) => (props.noBG ? 'inherit' : props.theme.colors.menu.link)};
	margin-bottom: 2px;
	overflow: hidden;
`
const LinkWrapper = styled(Link)`
	width: 100%;
	text-decoration: none;
`
const MenuText = styled.div`
	overflow: hidden;
	font-size: ${(props) => (props.extend === 'true' ? props.theme.font.fxs : props.theme.font.fm)};
	color: ${(props) => props.theme.colors.white};
	text-transform: capitalize;
	font-weight: bold;
	display: inline-block;
`
const MenuNested = styled.div`
	display: block;
	max-height: ${(props) =>
		({ transitionstate }) => {
			switch (transitionstate) {
				case 'entering':
					return '0px'
				case 'entered':
					return `${props.itemsNumber * 80}px`
				case 'exiting':
					return '0px'
				case 'exited':
					return '0px'
				default:
					return null
			}
		}};
	transition: all 0.1s;
	background-color: grey;
`
const MenuNestedLink = styled(Link)`
	text-decoration: none;
	& > :first-child {
		border-top: 2px solid #242424;
	}
	& > * {
		border-bottom: 2px solid #242424;
	}
	& > :last-child {
		border-bottom: none;
	}
`
const NestedMenuText = styled.div`
	overflow: hidden;
	display: flex;
	align-items: center;
	font-size: ${(props) => props.theme.font.fm};
	color: ${(props) => props.theme.colors.white};
	text-transform: capitalize;
	font-weight: bold;
`
const MenuIcon = styled.div`
	width: 50px;
	height: 50px;
	background-image: url('${(props) => props.src}');
	background-position: center;
	cursor: pointer;
	background-repeat: no-repeat;
	display: inline-block;
	background-size: ${(props) => (props.bgSize ? `${props.bgSize}%` : '')};
`
const DropMenu = styled.img`
	max-height: 15px;
	max-width: 15px;
`
const MenuWrapper = styled.div`
	display: grid;
	grid-template-columns: min-content 1fr min-content;
	align-items: center;
	column-gap: 5px;
	grid-template-rows: 50px;
`
const NestedLinkWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	align-items: center;
	padding: 5px 5px 5px 20px;
	background-color: ${(props) => props.theme.colors.menuNested.bcg};
	box-sizing: border-box;
	min-height: 50px;
	:hover {
		background-color: ${(props) => props.theme.colors.primary};
	}
	transition: background-color 0.1s;
`
const DropImgWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	transform: rotate(${(props) => (props.isToggleNested ? 0 : 180)}deg);
	margin-right: 15px;
`
/////////STYLED/////////

const MenuLink = ({ text, icon, nested, specAction, specActionIcon, subMenus, toggledNested, handleSetToggledNested, menuId, noBG, bgSize }) => {
	const { user } = useSelector(
		(state) => ({
			user: state.user.identity,
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleRedirect = () => {
		let target = process.env.REACT_APP_TARGET
		if (target.includes('recette')) {
			window.open('https://recette-vm-store.we-deal.fr/login', '_blank')
		} else if (target.includes('dev')) {
			window.open('https://dev-vm-store.we-deal.fr/login', '_blank')
		} else if (target.includes('pre-recette')) {
			window.open('https://recette-vm-store.we-deal.fr/login', '_blank')
		}
	}

	const isMenuLinkToggled = !isEmpty(toggledNested) ? toggledNested.toggle : false

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<MenuLinkWrapper nested={nested} onClick={specAction} noBG={noBG}>
			<LinkWrapper onClick={() => nested && handleSetToggledNested(menuId)}>
				<MenuWrapper>
					<MenuIcon onClick={specActionIcon} src={icon} bgSize={bgSize}></MenuIcon>
					<MenuText>{text}</MenuText>
					{nested && (
						<DropImgWrapper isToggleNested={isMenuLinkToggled}>
							<DropMenu src={DropIcon} alt="" />
						</DropImgWrapper>
					)}
				</MenuWrapper>
				{nested && (
					<Transition
						in={nested && isMenuLinkToggled}
						timeout={{
							appear: 0,
							enter: 0,
							exit: 300,
						}}
						mountOnEnter
						unmountOnExit
					>
						{(state) => (
							<MenuNested itemsNumber={subMenus.length} src={icon} transitionstate={state}>
								{map(subMenus, (elem) =>
									!elem.url ? (
										<UserAuthorizationLayout name={elem.requiredRight}>
											<MenuNestedLink to={elem.link}>
												<NestedLinkWrapper>
													{/*<NestedMenuIcon src={elem.icon}/>*/}
													<NestedMenuText>{elem.title}</NestedMenuText>
												</NestedLinkWrapper>
											</MenuNestedLink>
										</UserAuthorizationLayout>
									) : (
										(user.company.companyTyped.idCompanyType === 4 || user.company.companyTyped.idCompanyType === 8) && (
											<UserAuthorizationLayout name={elem.requiredRight}>
												<MenuNestedLink as={'div'} onClick={() => handleRedirect()}>
													<NestedLinkWrapper isUrl>
														{/*<NestedMenuIcon src={elem.icon}/>*/}
														<NestedMenuText>{elem.title}</NestedMenuText>
													</NestedLinkWrapper>
												</MenuNestedLink>
											</UserAuthorizationLayout>
										)
									)
								)}
							</MenuNested>
						)}
					</Transition>
				)}
			</LinkWrapper>
		</MenuLinkWrapper>
	)
}

export default MenuLink
